import script from "./Overage.vue?vue&type=script&setup=true&lang=ts"
export * from "./Overage.vue?vue&type=script&setup=true&lang=ts"

import "./Overage.vue?vue&type=style&index=0&id=c8929936&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8929936"]])

export default __exports__